import React, { useEffect, useState } from "react";
import "./footer.css";
import Sikh from "../../../src/assets/images/img/SikhLogo.png";
import { Link, useNavigate } from "react-router-dom"; // Ensure useNavigate is imported
import { BsYoutube, BsFacebook, BsInstagram } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import Magisticlogo from "../../../src/assets/images/img/megisticLogo2.png";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { needCall } from "../Header/Data";
import { FaPhoneAlt } from "react-icons/fa";
import { listGurudwaras } from "../Header/Data";
import { Button, Modal, ModalBody, FormGroup, Label, Input } from "reactstrap";
import { GrFormClose } from "react-icons/gr";
import DonateModal from "../Header/modals/DonateModal";
import {
  setDonationClientId,
  setDonationFrom,
  setDonationSecretKey,
  setDonationStatus,
  setMonthlyDonation,
  setOpenPaypal,
  setSelectedAmount,
  setSelectedGurdwara,
} from "../../redux/slices/DonationSlice";
import ThankYouModal from "../../pages/DashboardPages/Orders/ThankYouPage";
import {
  setActiveTab,
  setSelectedSubCategory,
  setViewCustType,
} from "../../redux/slices/LcaSlice";

const Footer = () => {
  const [privacy, setPrivacy] = useState("");
  const [shipping, setShipping] = useState("");
  const [isOpen, setIsOpen] = useState("");
  const [gurdwaras, setGurdwaras] = useState([]);
  const location = useLocation();
  const navigate = useNavigate(); // Initialize navigate
  const dispatch = useDispatch();

  const isHomePage =
    location.pathname === "/" ||
    location.pathname === "/home" ||
    location.pathname === "/Localcommunityads";
  const isBrowsePage = location.pathname === "/weddingvendors";
  const isMajesticHomePage = location.pathname === "/majesticHomePage";
  const isVendorDetailsPage = location.pathname.includes("/vendordetails");
  const isInvoicePaymentPage = location.pathname.includes("/invoicePayment");

  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;

  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );

  const [modal, setModal] = useState(false);
  const [gurdwaraId, setGurdwaraId] = useState(null);
  const [gurdwaraName, setGurdwaraName] = useState("");
  const toggleModal = () => {
    if (!isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    setModal(!modal);
  };

  const { donationStatus, donationFrom } = useSelector(
    (state) => state.gurdwaraDonation
  );

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalClosed, setModalClosed] = useState(false);
  const [thankYou, setThankYou] = useState(false);
  const donationType = "Footer";

  const handleClick = (e) => {
    const selectedValue = e.target.value;
    const selectedGurdwaraData = gurdwaras.find(
      (gurudwara) => gurudwara.Id === parseInt(selectedValue)
    );

    setGurdwaraId(selectedValue);
    setGurdwaraName(selectedGurdwaraData ? selectedGurdwaraData.Title : "");
  };

  const handleSubmit = () => {
    if (!isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    const cleanedGurdwaraName = gurdwaraName.replace(/\s+/g, "");
    if (cleanedGurdwaraName === "") {
      toast.error("Please select Gurdwara");
      return;
    }
    window.open(`#/bookGurdwara/${cleanedGurdwaraName}?id=${gurdwaraId}`);
    toggleModal();
  };

  const handleZoomWelcomePageClick = () => {
    window.scrollTo(0, 0);
  };

  const fetchData = async () => {
    const gurudwaras = await listGurudwaras();
    setGurdwaras(gurudwaras);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (donationFrom === "FOOTER" && donationStatus === "COMPLETED") {
      setModalIsOpen(false);
      setModalClosed(true);
      dispatch(setDonationStatus(""));
      dispatch(setDonationFrom(""));
      setThankYou(true);
    }
  }, [donationStatus]);

  // Helper function to handle navigation with profile check
  const handleNavigation = (path) => {
    if (!isProfileComplete) {
      toast.info("Please complete your profile.");
      return;
    }
    navigate(path);
  };

  return (
    <>
      <footer className="py-4 bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="office__info pe-5">
                {isBrowsePage ||
                isMajesticHomePage ||
                isVendorDetailsPage ||
                isInvoicePaymentPage ? (
                  <img
                    className="d-lg-block wc-logo2"
                    src={Magisticlogo}
                    alt="logo"
                  />
                ) : (
                  <img className="d-lg-block wc-logo" src={Sikh} alt="logo" />
                )}
                <div className="social_icons d-flex align-items-center gap-15 mt-4">
                  <a
                    href="https://www.youtube.com/channel/UCDktIvmaFNB5rcAOevDXUrw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsYoutube className="fs-5" />
                  </a>
                  <a
                    href="https://www.facebook.com/people/Indian-Wedding-Vendors-LLC/100088337712267/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsFacebook className="fs-5" />
                  </a>
                  <a
                    href="https://www.instagram.com/myindiancommunity/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BsInstagram className="fs-5" />
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="footer-links d-flex flex-column">
                <Link
                  className="text-dark py-2 mb-1"
                  to=""
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("");
                  }}
                >
                  Sell
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to="/weddingvendors"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/weddingvendors");
                  }}
                >
                  Browse Listing
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to={`about/shipping/${shipping}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(`about/shipping/${shipping}`);
                  }}
                >
                  Browse Action
                </Link>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="footer-links d-flex flex-column">
                <Link
                  className="text-dark py-2 mb-1"
                  to="/privacypolicies"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/privacypolicies");
                  }}
                >
                  Privacy Policies
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to="/aboutus"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/aboutus");
                  }}
                >
                  About Us
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to="/contact/us/ll"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/contact/us/ll");
                  }}
                >
                  Contact Us
                </Link>
                <Link
                  className="text-dark py-2 mb-1"
                  to="/pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation("/pricing");
                  }}
                >
                  Pricing
                </Link>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <Link
                to="/need/request"
                className="text-decoration-underline"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation("/need/request");
                }}
              >
                Post Your Ad
              </Link>
              <br />
              {isHomePage && (
                <p
                  className="mt-3 mb-2 text-primary text-decoration-underline"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!isProfileComplete) {
                      toast.info("Please complete your profile.");
                      return;
                    }
                    dispatch(setViewCustType(true));
                  }}
                >
                  View Customers
                </p>
              )}
              <button
                type="button"
                className="btn btn-sm btn-primary mt-3"
                onClick={toggleModal}
              >
                <span className="mx-1">Book a Gurdwara</span>
              </button>
              <Modal isOpen={modal} toggle={toggleModal}>
                <ModalBody>
                  <div className="d-flex justify-content-between">
                    <h5 className="mt-2">Select Gurdwara</h5>
                    <h5 className="btn btn-sm" onClick={toggleModal}>
                      <GrFormClose size={30} />
                    </h5>
                  </div>
                  <FormGroup>
                    <Label for="gurdwaraSelect">Choose a Gurdwara</Label>
                    <Input
                      type="select"
                      name="gurdwara"
                      id="gurdwaraSelect"
                      value={gurdwaraId || ""}
                      onChange={(e) => handleClick(e)}
                    >
                      <option value="0">Select Gurdwara</option>
                      {gurdwaras.map((gurudwara) => (
                        <option key={gurudwara.Id} value={gurudwara.Id}>
                          {gurudwara.Title}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <div className="d-flex justify-content-end gap-10">
                    <Button color="primary" onClick={handleSubmit}>
                      Submit
                    </Button>
                  </div>
                </ModalBody>
              </Modal>
              <div>
                <button
                  className="btn btn-sm btn-primary mt-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (!isProfileComplete) {
                      toast.info("Please complete your profile.");
                      return;
                    }
                    setModalIsOpen(true);
                    dispatch(setDonationFrom("FOOTER"));
                  }}
                >
                  Donate to Gurdwara
                </button>
              </div>
              <DonateModal
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
                Type={donationType}
                onClose={() => {
                  setModalClosed(true);
                  setModalIsOpen(false);
                }}
                handleFormSubmit={true}
              />
            </div>
            {isBrowsePage ||
            isMajesticHomePage ||
            isVendorDetailsPage ||
            isInvoicePaymentPage ? (
              <p className="footer__copyright mb-0 text-dark align-items-center">
                © Majestic Events All rights reserved
              </p>
            ) : (
              <p className="footer__copyright mb-0 text-dark align-items-center">
                © My Sikh Community.COM All rights reserved
              </p>
            )}
          </div>
        </div>
      </footer>
      <ThankYouModal
        show={thankYou}
        onHide={() => setThankYou(false)}
        state={{ donation: true }}
      />
    </>
  );
};

export default Footer;
